<template>
	<div class="message-controls-wrap">
		<p v-if="createdAt" class="message-date">{{ createdAtFormat }}</p>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import moment from 'moment'

const props = defineProps({
	createdAt: { type: String, default: '' }
})

const createdAtFormat = computed(() => (props.createdAt ? moment(props.createdAt).format('DD.MM.YYYY HH:mm') : ''))
</script>

<style lang="scss" scoped>
.message-date {
	text-align: right;
	font: var(--font-caption);
	height: 20px;
}
</style>
